module.exports = __webpack_public_path__ + "static/img/ban_2.0cb0edee.png";